/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precision tools for what matters`)
};

const es_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de precisión para lo que importa`)
};

const de_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Präzisionswerkzeuge für das, was zählt`)
};

const nl_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisietools voor wat telt`)
};

const fr_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils de précision pour ce qui compte`)
};

const it_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di precisione per ciò che conta`)
};

const pt_br2_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de precisão para o que importa`)
};

const pt_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de precisão para o que importa`)
};

const ja_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大切なことのための精度ツール`)
};

const zh_home_badge = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为重要事务打造的精准工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_badge = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_badge(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_badge", locale)
	if (locale === "en") return en_home_badge(inputs)
	if (locale === "es") return es_home_badge(inputs)
	if (locale === "de") return de_home_badge(inputs)
	if (locale === "nl") return nl_home_badge(inputs)
	if (locale === "fr") return fr_home_badge(inputs)
	if (locale === "it") return it_home_badge(inputs)
	if (locale === "pt-BR") return pt_br2_home_badge(inputs)
	if (locale === "pt") return pt_home_badge(inputs)
	if (locale === "ja") return ja_home_badge(inputs)
	return zh_home_badge(inputs)
};